var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.098,
    height: 15.364,
    viewBox: "0 0 15.098 15.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings",
    transform: "translate(-2.173 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8735",
    "data-name": "Path 8735",
    d: "M10.145,4a6.145,6.145,0,1,0,6.145,6.145A6.146,6.146,0,0,0,10.145,4Zm0,9.218a3.073,3.073,0,1,1,3.073-3.073A3.073,3.073,0,0,1,10.145,13.218Z",
    transform: "translate(-0.424 -0.464)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8736",
    "data-name": "Path 8736",
    d: "M11.963,4.3,11.514,2H7.93L7.481,4.3ZM7.481,15.059l.449,2.3h3.584l.449-2.3ZM6.185,5.053l-2.22-.764L2.173,7.393l1.771,1.54Zm7.073,9.258,2.22.764,1.792-3.105L15.5,10.43ZM3.944,10.43,2.173,11.97l1.792,3.105,2.22-.764ZM15.5,8.934l1.771-1.54L15.479,4.288l-2.22.764Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.363a563fb34b2048da9eba4de5752669.svg";
export { ForwardRef as ReactComponent };